import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AskGodPage from "@/pages/AskGodPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import SharedAnswerPage from "@/pages/SharedAnswerPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AskGodPage />} />
          <Route path="/a/:id" element={<SharedAnswerPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="*" element={<AskGodPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#5C0E1D",
            color: "#FFFFFF",
            border: "1px solid rgba(197, 160, 89, 0.35)",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
